var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 1.5 3.75 C 1.5 3.335938 1.835938 3 2.25 3 L 8 3 C 9.261719 3 10.46875 3.5 11.359375 4.390625 C 12.25 5.28125 12.75 6.488281 12.75 7.75 L 12.75 21.75 C 12.75 22.164062 12.414062 22.5 12 22.5 C 11.585938 22.5 11.25 22.164062 11.25 21.75 C 11.25 21.152344 11.011719 20.582031 10.589844 20.160156 C 10.167969 19.738281 9.597656 19.5 9 19.5 L 2.25 19.5 C 1.835938 19.5 1.5 19.164062 1.5 18.75 Z M 11.25 18.75 L 11.25 7.75 C 11.25 6.886719 10.90625 6.0625 10.296875 5.453125 C 9.6875 4.84375 8.863281 4.5 8 4.5 L 3 4.5 L 3 18 L 9 18 C 9.816406 18 10.605469 18.265625 11.25 18.75 Z M 11.25 18.75 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 12.640625 4.390625 C 13.53125 3.5 14.738281 3 16 3 L 21.75 3 C 22.164062 3 22.5 3.335938 22.5 3.75 L 22.5 18.75 C 22.5 19.164062 22.164062 19.5 21.75 19.5 L 15 19.5 C 14.402344 19.5 13.832031 19.738281 13.410156 20.160156 C 12.988281 20.582031 12.75 21.152344 12.75 21.75 C 12.75 22.164062 12.414062 22.5 12 22.5 C 11.585938 22.5 11.25 22.164062 11.25 21.75 L 11.25 7.75 C 11.25 6.488281 11.75 5.28125 12.640625 4.390625 Z M 12.75 18.75 C 13.394531 18.265625 14.183594 18 15 18 L 21 18 L 21 4.5 L 16 4.5 C 15.136719 4.5 14.3125 4.84375 13.703125 5.453125 C 13.09375 6.0625 12.75 6.886719 12.75 7.75 Z M 12.75 18.75 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.963f4c2a8c2e642ed6940a5e78a07a53.svg";
export { ForwardRef as ReactComponent };